import axios from 'axios';
import { getBackendURL } from '../Utils/ServerURL';
import { STARTING_TABLE_PAGE, DEFAULT_ROWS_PER_PAGE, ORDER_BY_BRAND, ORDER_ASCENDING } from '../Utils/Constants';
const sControllerEndpoint = 'Transportation';


export class UsedRentalsTransportAPI {
  params;

  constructor() {
    this.params = {};
  }

  getRUTransportsLots(page = STARTING_TABLE_PAGE, rowsPerPage = DEFAULT_ROWS_PER_PAGE, orderBy = ORDER_BY_BRAND, order = ORDER_ASCENDING, searchBy = '') {
    this.params = {
      page: page,
      rowsPerPage: rowsPerPage,
      orderBy: orderBy,
      order: order
    }
    if (searchBy)
      this.params.searchBy = searchBy;
    return axios.get(getBackendURL() + sControllerEndpoint + '/GetTransportListL1RU', { params: this.params });
  }

  getRUTransportsCars(page = STARTING_TABLE_PAGE, rowsPerPage = DEFAULT_ROWS_PER_PAGE, orderBy = '', order = ORDER_ASCENDING, searchBy = '', ruL1Id) {
    this.params = {
      ruL1Id: ruL1Id,
      page: page,
      rowsPerPage: rowsPerPage
    }
    if (searchBy)
      this.params.searchBy = searchBy;
    if (orderBy)
      this.params.orderBy = orderBy;
    if (order)
      this.params.order = order;
    return axios.get(getBackendURL() + sControllerEndpoint + '/GetTransportL4RU', { params: this.params });
  }

  getRUTransportsCarsWAD(page = STARTING_TABLE_PAGE, rowsPerPage = DEFAULT_ROWS_PER_PAGE, orderBy = '', order = ORDER_ASCENDING, searchBy = '') {
    this.params = {
      page: page,
      rowsPerPage: rowsPerPage
    }
    if (searchBy)
      this.params.searchBy = searchBy;
    if (orderBy)
      this.params.orderBy = orderBy;
    if (order)
      this.params.order = order;
    return axios.get(getBackendURL() + sControllerEndpoint + '/GetWaitingArrivalL4RU', { params: this.params });
  }

  getRUTransportsCarsWRT(page = STARTING_TABLE_PAGE, rowsPerPage = DEFAULT_ROWS_PER_PAGE, orderBy = '', order = ORDER_ASCENDING, searchBy = '') {
    this.params = {
      page: page,
      rowsPerPage: rowsPerPage
    }
    if (searchBy)
      this.params.searchBy = searchBy;
    if (orderBy)
      this.params.orderBy = orderBy;
    if (order)
      this.params.order = order;
    return axios.get(getBackendURL() + sControllerEndpoint + '/GetWaitingTransportL4RU', { params: this.params });
  }

  getRUTransportsCarsAtD(page = STARTING_TABLE_PAGE, rowsPerPage = DEFAULT_ROWS_PER_PAGE, orderBy = '', order = ORDER_ASCENDING, searchBy = '') {
    this.params = {
      page: page,
      rowsPerPage: rowsPerPage
    }
    if (searchBy)
      this.params.searchBy = searchBy;
    if (orderBy)
      this.params.orderBy = orderBy;
    if (order)
      this.params.order = order;
    return axios.get(getBackendURL() + sControllerEndpoint + '/GetOnDestinyL4RU', { params: this.params });
  }

  updateRUTransportByCar(dto) {
    return axios.put(getBackendURL() + sControllerEndpoint + '/UpdateTransportL4RU', dto);
  }

}

export default UsedRentalsTransportAPI


// WEBPACK FOOTER //
// ./src/API/UsedRentalsTransportAPI.js